module.exports = __webpack_public_path__ + "static/media/to.ee39c2db.svg";